import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PaymentService, config } from "@fgb/core";
import { ProviderUiActionResponse } from "@fgb/core";

@Component({
  selector: "fgb-ecash-result",
  templateUrl: "ecash-result-page.component.html",
})
export class EcashResultPageComponent implements OnInit {
  response = new ProviderUiActionResponse();
  private route = inject(ActivatedRoute);

  constructor(private paymentService: PaymentService, private router: Router) {}

  ngOnInit() {
    this.processCallBack();
  }

  processCallBack() {
    const purchaseOrderId =
      this.route.snapshot.queryParamMap.get("purchaseOrderId") || undefined;

    const callbackUrl = config.baseApiUrl + this.router.url;

    const params = {
      purchaseOrderId,
    };

    this.paymentService.completePayment(
      params,
      callbackUrl,
      "/ecash/success",
      "/ecash/failure"
    );
  }
}
